
export class Text_lois {
    id_text:number;
    libelle_text:any;
    etat_text:any;
    fichier_text : any;
    matricule_pers:any;
    date_entre_text:Date;
  
    
       
    constructor(id_text:number){
           
    }
}
